import { useEffect, useState } from "react";
import { formatDateFunction } from "../../../../../utils/helper/utils";
import { CiCircleInfo } from "react-icons/ci";
import { Tooltip } from "antd";

const Bills = ({ priceDetails = {}, refund = {}, couponDetails, transactions = [] }) => {
  const [transactionsData, setTransactions] = useState({});
  const formatAmount = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };
  const totalDiscount =
    formatAmount(priceDetails?.coupon_discount) +
    formatAmount(priceDetails?.pickup_discount) +
    formatAmount(priceDetails?.timeslot_discount);

  useEffect(() => {
    if (transactions.length > 0) {
      for (let item of transactions) {
        if (item.paymentStatus === "CAPTURED") {
          setTransactions(item);
        }
      }
    } else setTransactions({});
  }, [transactions]);

  return (
    <>
      <div className="px-9 py-5  border-gray-250 border-b w-full ">
        <table className="w-full border-separate border-spacing-y-1">
          <tbody>
            <tr>
              <td className="text-sm font-medium ">Item Total</td>
              <td className="text-sm font-medium text-right ">SAR {formatAmount(priceDetails?.sub_total).toFixed(2)}</td>
            </tr>
            {totalDiscount > 0 ? (
              <tr>
                <td className="text-sm font-medium text-gray-200">
                  <div className="text-sm text-gray font-medium flex items-center gap-1">
                    Discounts{" "}
                    <Tooltip
                      color="#ffffff"
                      title={
                        <div className="text-black">
                          You are applied following discounts :<br />
                          {priceDetails?.coupon_discount && formatAmount(priceDetails?.coupon_discount) > 0
                            ? `Coupon code : ` + formatAmount(priceDetails?.coupon_discount).toFixed(2) + `, `
                            : null}
                          {priceDetails?.pickup_discount && formatAmount(priceDetails?.pickup_discount) > 0
                            ? `Dropzone : SAR ` + formatAmount(priceDetails?.pickup_discount).toFixed(2) + `, `
                            : null}
                          {priceDetails?.timeslot_discount && formatAmount(priceDetails?.timeslot_discount) > 0
                            ? `Timeslot : SAR ` + formatAmount(priceDetails?.timeslot_discount).toFixed(2)
                            : null}
                        </div>
                      }
                    >
                      <CiCircleInfo />
                    </Tooltip>
                  </div>
                </td>
                <td className="text-sm font-medium text-gray-200 text-right ">
                  - SAR {formatAmount(priceDetails?.coupon_discount) + formatAmount(priceDetails?.pickup_discount) + formatAmount(priceDetails?.timeslot_discount)}
                </td>
              </tr>
            ) : null}
            <tr>
              <td className="text-sm font-medium text-gray-200 ">Tax (VAT 15%)</td>
              <td className="text-sm font-medium text-gray-200 text-right ">SAR {formatAmount(priceDetails?.vat).toFixed(2)}</td>
            </tr>
              <tr>
                <td className="text-sm font-medium text-gray-200"><span className="block">Delivery Fees</span>
                  {priceDetails?.distanceKM  ? (
                  <span className="block">({parseFloat(priceDetails?.distanceKM).toFixed(2)} KM)</span>
                  ) : null}
                </td>
                <td className="text-sm font-medium text-gray-200 text-right ">SAR {formatAmount(priceDetails?.delivery_fees).toFixed(2)}</td>
              </tr>
            {/* {priceDetails?.platform_fees > 0 ? (
              <tr>
                <td className="text-sm font-medium text-gray-200 ">
                  Platform fees
                </td>
                <td className="text-sm font-medium text-gray-200 text-right ">
                  SAR {parseFloat(priceDetails?.platform_fees).toFixed(2)}
                </td>
              </tr>
            ) : null} */}
            {/* {priceDetails?.pickup_discount > 0 ? (
              <tr>
                <td className="text-sm font-medium text-gray-200 ">
                  Pickup Discount
                </td>
                <td className="text-sm font-medium text-gray-200 text-right ">
                  - SAR {parseFloat(priceDetails?.pickup_discount).toFixed(2)}
                </td>
              </tr>
            ) : null} */}
            <tr>
              <td className="text-sm font-semibold ">Bill Total (Amount payable by customer)</td>
              <td className="text-right font-semibold text-base ">SAR {formatAmount(priceDetails?.total_amount).toFixed(2)}</td>
            </tr>
            {Object.keys(refund).length > 0 ? (
              <>
                <tr>
                  <td className="text-sm font-medium text-gray-200 ">Refund to Customer</td>
                  <td className="text-sm font-medium text-gray-200 text-right ">SAR {formatAmount(refund?.amount).toFixed(2)}</td>
                </tr>
                {formatAmount(refund?.vendor_amount) > 0 ? (
                  <tr>
                    <td className="text-sm font-medium text-gray-200 ">Refund to Vendor</td>
                    <td className="text-sm font-medium text-gray-200 text-right ">SAR {formatAmount(refund?.vendor_amount).toFixed(2)}</td>
                  </tr>
                ) : null}
                {formatAmount(refund?.pickup_vendor_amount) > 0 ? (
                  <tr>
                    <td className="text-sm font-medium text-gray-200 ">Refund to Host</td>
                    <td className="text-sm font-medium text-gray-200 text-right ">
                      SAR {formatAmount(refund?.pickup_vendor_amount).toFixed(2)}
                    </td>
                  </tr>
                ) : null}
              </>
            ) : null}
          </tbody>
        </table>
        {/* The card details section below will change when the end status is updated */}
        {transactionsData && Object.keys(transactionsData).length > 0 ? (
          <div className="inline-flex	 bg-[#FBFAF9] py-2	px-3 items-center mt-2">
            <img src="images/visa-card.png" alt="visa-thumbnail" className="w-[32px] h-[32px] rounded" />
            <div className="pl-2">
              <h3 className="text-sm font-semibold">
                Paid by card ending xxxxxxxxxxxx
                {transactionsData?.chargeResponseJson?.card?.last_four}
              </h3>
              <p className="text-gray-200 text-xs pt-[4px]">
                On {formatDateFunction(transactionsData?.createdAt, "dd/mm/yyyy", true)} | Transaction ID #
                {transactionsData?.chargeResponseJson?.id}
              </p>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
export default Bills;
